module.exports = __webpack_public_path__ + "static/img/robot.ad50ddfa.webp";